// ملف مساعد للتعامل الآمن مع البيانات
export const safeArray = <T,>(data: any): T[] => {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (data && typeof data === 'object') return Object.values(data);
  return [];
};

export const safeFilter = <T,>(data: any, predicate: (item: T) => boolean): T[] => {
  const arr = safeArray<T>(data);
  return arr.filter(predicate);
};

export const safeFind = <T,>(data: any, predicate: (item: T) => boolean): T | undefined => {
  const arr = safeArray<T>(data);
  return arr.find(predicate);
};